// extracted by mini-css-extract-plugin
export var blueText = "index-module--blueText--d79cd";
export var excellenceImage = "index-module--excellenceImage--96cfd";